<!-- @format -->
<script lang="ts">
  import type { Link } from "~/components/field-utils";
  export let linkTitle: Link = {
    text: "",
    href: "",
    outbound: false,
  };
  export let titleTextColor = "#6950a1"
  const { text, href, outbound } = linkTitle;

  $: target = outbound == true ? "_blank" : "";

</script>

{#if href && text}
  <a href={href} {target}>
    <div class="title-outline font-reliable" style="color: {titleTextColor}">
      {text}
    </div>
  </a>
{/if}

<style lang="scss">
  .title-outline {
    font-size: 45px;
    text-align: center;
    text-transform: uppercase;
    line-height: 1;
    color: var(--color-accent-primary);
    padding: 0 16px 40px 16px;
    @media screen and (min-width: 576px) {
      padding-bottom: 0 16px 55px 16px;
    }
    @media screen and (min-width: 768px) {
      font-size: 55px;
    }
  }
  a:hover{
    text-decoration: none;
  }
</style>
